import React from 'react'
import {css} from '@emotion/react'
import {Typography} from '@mui/material'

import JSONView from '../../../../components/modules/JSONView/JSONView'


export default function JSONArea({data, ...props}) {
  const styles = {
    root: css`
      height: 100%;
      margin-top: 0;
      padding: 4px;

      position: relative;
      overflow: auto;
      
      border-style: solid;
      border-width: 1px;
      border-color: rgba(0, 0, 0, 0.23);
      border-radius: 4px;
      
      &:hover {
        border-color: rgba(0, 0, 0, 0.87);
      }
    `,
  }

  return (
    <div css={styles.root} {...props}>
      {data instanceof Error ? (
        <Typography>{data.toString()}</Typography>
      ) : (
        <JSONView
          data={data}
        />
      )}
    </div>
  )
}
